import React, { useEffect, useState } from "react";
import Grid from "@material-ui/core/Grid";
import {
  Typography,
  FormControl,
  TextField,
  Button,
  withStyles,
} from "@material-ui/core";
import { DatePicker, MuiPickersUtilsProvider } from "material-ui-pickers";
import MomentUtils from "@date-io/moment";
import moment from "moment";
import "moment/locale/pt-br";
import { useTranslations } from "adapters/i18n";
const locale = "pt-BR";
moment.locale(locale);

export const PesagemCategoriaHeader = ({
  classes,
  editar,
  criarNovoEventoPesagem,
  criarNovo,
  pesagens,
}) => {
  const [controleData, setControleData] = useState(moment());
  const [erroData, setErroData] = useState(false);
  const [controleNomeDoEvento, setControleNomeDoEvento] = useState("");
  const [exibirMensagem, setExibirMensagem] = useState(false);
  const { t } = useTranslations();

  const regexData = [/\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/];

  useEffect(() => {
    if (
      pesagens.some((pesagem) =>
        moment(pesagem.DataPesagem).isSame(
          moment(controleData).format("YYYY-MM-DD")
        )
      )
    ) {
      setErroData(true);
      setExibirMensagem(true);
    } else {
      setErroData(false);
      setExibirMensagem(false);
    }
  }, [pesagens, controleData]);

  const alteraData = (value) => {
    if (
      pesagens.some((pesagem) =>
        moment(pesagem.DataPesagem).isSame(moment(value).format("YYYY-MM-DD"))
      )
    ) {
      setErroData(true);
      setExibirMensagem(true);
    } else {
      setErroData(false);
      setExibirMensagem(false);
    }
    setControleData(value);
  };
  return (
    <React.Fragment>
      <Grid item className={classes.containerPage}>
        <Typography
          id="pesagemCategoriaTitulo"
          className={classes.titulo}
          gutterBottom
        >
          {t("animalCategory:weighing-registration-by-category")}
        </Typography>
      </Grid>
      {!editar && !criarNovo && (
        <Grid>
          <Grid
            container
            alignItems={"center"}
            direction={"row"}
            xs={12}
            md={12}
            className={classes.menssageAlerta}
          >
            <Typography className={classes.textoAlerta}>
              {t("animalCategory:date-and-event-of-the-weigh-in-day")}
            </Typography>
          </Grid>
          <Grid
            container
            xs={12}
            md={12}
            direction="row"
            justify="space-between"
          >
            <Grid style={{ display: "flex" }} item>
              <Grid item>
                <FormControl id="formEvento" className={classes.textoBuscar}>
                  <TextField
                    className={classes.textField}
                    id="nomeEventoPesagem"
                    inputProps={{
                      "data-testid": "nomeEventoPesagem",
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    focused
                    label={t("animalCategory:weigh-in-event-name")}
                    style={{ minWidth: "300px", marginRight: "40px" }}
                    value={controleNomeDoEvento}
                    onChange={({ target: { value } }) =>
                      setControleNomeDoEvento(value)
                    }
                  />
                </FormControl>
              </Grid>
              <Grid item>
                <Grid item>
                  <MuiPickersUtilsProvider
                    locale={locale}
                    moment={moment}
                    utils={MomentUtils}
                  >
                    <DatePicker
                      disableFuture
                      keyboard
                      mask={(value) => (value ? regexData : [])}
                      disableOpenOnEnter
                      id="data-pesagem-DataPicker"
                      data-testid="data-pesagem-DataPicker"
                      label={t("animalCategory:weighing-date")}
                      onChange={alteraData}
                      invalidDateMessage={t(
                        "common:validation.invalid-date-format"
                      )}
                      minDateMessage={t("common:validation.invalid-date")}
                      maxDateMessage={t("common:validation.invalid-date")}
                      format="DD/MM/YYYY"
                      placeholder="dd/mm/aaaa"
                      value={controleData}
                      onError={() => setErroData(true)}
                      onInputChange={(e) => {
                        if (
                          e.target.value.includes("_") >= 0 ||
                          e.target.value === ""
                        ) {
                          setExibirMensagem(false);
                        }
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </Grid>
                <Grid item>
                  {exibirMensagem && (
                    <div>
                      <Typography className={classes.textoAlerta}>
                        {t("animalCategory:date-already-has-a-registration")}
                      </Typography>
                    </div>
                  )}
                </Grid>
              </Grid>
            </Grid>
            <Grid item>
              <Button
                id="botaoCriarEvento"
                data-testid="botaoCriarEvento"
                onClick={() =>
                  criarNovoEventoPesagem(controleNomeDoEvento, controleData)
                }
                variant="contained"
                color="primary"
                style={{ height: "41px" }}
                disabled={!controleNomeDoEvento || !controleData || erroData}
              >
                {t("common:actions.create-new")}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      )}
    </React.Fragment>
  );
};

const styles = () => ({
  containerPage: {
    flexgrow: 1,
    height: "100%",
    backgroundColor: "#fff",
    width: "100%",
  },
  titulo: {
    fontSize: "20px",
    fontWeight: "bold",
    fontStyle: "medium",
    fontStretch: "medium",
    lineHeight: "medium",
    letterSpacing: "medium",
    color: "#333333",
    marginTop: "40px",
  },
  textoAlerta: {
    color: "#424242",
    fontSize: 12,
    fontFamily: "Roboto",
    alignSelf: "flex-end",
  },
  menssageAlerta: {
    marginTop: 30,
    marginBottom: 30,
  },
});

export default withStyles(styles)(PesagemCategoriaHeader);
